<template>
    <DiscoverDetailPage
        v-if="entry"
        :entry="entry"
    >
        <template #breadcrumb>
            <BreadcrumbNavigation :parent-path="localePath('/actueel')" />
        </template>
    </DiscoverDetailPage>
</template>

<script setup>
import DiscoverEntryQuery from '~/graphql/queries/discover/discoverEntry.graphql';
import DiscoverDetailPage from '~/patterns/pages/discover-detail.vue';

defineI18nRoute({
    paths: {
        nl: '/agenda/[slug]',
        en: '/agenda/[slug]'
    }
});

const { variables } = useDefaultVariables();

const response = await useAsyncQuery({
    query: DiscoverEntryQuery,
    variables
});

const { craftEntry: entry } = useEntryPage(response);

useHead({
    bodyAttrs: {
        'data-color-theme': 'dark'
    }
});

useNavigationVisible();
useDarkTheme();
useCollapse();

const localePath = useLocalePath();
</script>
